import PropTypes from 'prop-types';
import React from 'react';

import t from '../../lib/I18n';

const mapFacilities = (facilities) => {
    return facilities.map((currentFacility, index) => {
        const key = `facility-${index}`;
        const currentFacilityNoCamelCase = currentFacility.replace(/([A-Z])/g, ' $1').trim();
        const facilitySplit = (index !== facilities.length - 1) ? ',' : '.';

        return (
            <li key={ key }>
                <div className="stationFinder__modal-facility">{ currentFacilityNoCamelCase }{ facilitySplit }</div>
            </li>
        );
    });
};

export default function StationFacilities({ facilities }) {
    return (
        <div className="stationFinder__modal-details stationFinder__modal-facilities">
            <h3>{ t('stationFinder.modal.facilities') }</h3>
            <ul>
                { mapFacilities(facilities) }
            </ul>
        </div>
    );
}

StationFacilities.propTypes = {
    facilities: PropTypes.array,
};

StationFacilities.defaultProps = {
    facilities: [],
};



// WEBPACK FOOTER //
// ./src/components/stationFinder/StationFacilities.js